import { createFileRoute, Outlet } from '@tanstack/react-router'
import LayoutSidebarScrollAreas from '@/components/layout/LayoutSidebarScrollAreas'
import Loader from '@/components/shared/Loader'
import NotFound from '@/routes/-NotFound'
import ErrorPage from '@/routes/-ErrorPage'

export const Route = createFileRoute('/_default')({
  component: LeaLayout,
  pendingComponent: () => (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ position: 'fixed', inset: 0, backgroundColor: 'var(--background)', zIndex: 2000 }}
    >
      <Loader containerClass="py-4 spinner-navy" />
    </div>
  ),
  notFoundComponent: () => {
    return (
      <LayoutSidebarScrollAreas>
        <NotFound />
      </LayoutSidebarScrollAreas>
    )
  },
  errorComponent: () => {
    return (
      <LayoutSidebarScrollAreas>
        <ErrorPage />
      </LayoutSidebarScrollAreas>
    )
  },
})

function LeaLayout() {
    return (
      <LayoutSidebarScrollAreas>
        <Outlet/>
      </LayoutSidebarScrollAreas>
    )
}